<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10" v-if="totalResults">
        <div class="row" v-if="searchResults.products.length">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Product Results</h1>
          </div>
          <ItemCard v-for="product in searchResults.products" :key="product.id" :item="product" :nextLink="'/product/' + product.id + '/images'"></ItemCard>
        </div>

        <div class="row" v-if="searchResults.brandings.length">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Branding Results</h1>
          </div>
          <ItemCard v-for="branding in searchResults.brandings" :key="branding.id" :item="branding" :nextLink="'/download/branding/' + branding.id"></ItemCard>
        </div>

        <div class="row" v-if="searchResults.presentations.length">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Presentation Results</h1>
          </div>
          <ItemCard v-for="presentation in searchResults.presentations" :key="presentation.id" :item="presentation" :nextLink="'/download/presentation/' + presentation.id"></ItemCard>
        </div>

        <div class="row" v-if="searchResults.photoImages.length">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Photo Image Results</h1>
          </div>
          <ItemCard v-for="image in searchResults.photoImages" :key="image.id" :item="image" :nextLink="'/download/photo_image/' + image.id"></ItemCard>
        </div>
      </div>
      <div class="not-found-div" v-else>
        <div class="row">
            <div class="col-md-12">
              <h1 class="heading-color text-center p-5">Search Results</h1>
              <p class="text-center mt-0">Nothing found under "{{query}}"</p>
            </div>
          </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Product from '@/models/Product'
import Branding from '@/models/Branding'
import Presentation from '@/models/Presentation'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Search',
  components: {
    ItemCard,
    Product,
    Branding,
    Presentation
  },
  data () {
    return {
      searchResults: null,
      totalResults: 0
    }
  },
  computed: {
    query () {
      return this.$route.query.query
    }
  },
  watch: {
    '$route.query.query': function () {
      this.search()
    }
  },
  mounted () {
    if (!this.query) {
      this.$router.back()
      // this.$router.push('/')
    }
    this.search()
  },
  methods: {
    search () {
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('search', this.query)
        .then((result) => {
          this.searchResults = result.data.searchResults
          this.totalResults = result.data.totalResults
          $('.overlay').addClass('d-none')
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(90vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(90vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search.vue